import { LeihBarPermissions, PermissionEnum } from '@thro-types/access-handler';
import { User } from '@thro-types/users';

import { Route, Routes, useLocation } from 'react-router';

import { useSelfEntitlementGroupsQuery } from 'api/hooks/users';
import PrivateRoute from 'app/components/Util/PrivateRoute';

import { canUserEdit } from '../helper';
import { CreateProductPage } from './CreateProductPage';
import { ProductOverview } from './ProductOverview';

export const Products = ({
  currentUser,
  userPermission
}: {
  currentUser: User;
  userPermission: PermissionEnum[];
}) => {
  const location = useLocation();
  const { data: myEntitlementGroups } = useSelfEntitlementGroupsQuery();

  return (
    <Routes>
      <Route
        path=":id"
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={LeihBarPermissions.LEIHBAR_PRODUCT_READ}
          >
            <ProductOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="create"
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={LeihBarPermissions.LEIHBAR_PRODUCT_CREATE}
          >
            <CreateProductPage />
          </PrivateRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={LeihBarPermissions.LEIHBAR_PRODUCT_EDIT_ANY}
            canAccess={
              location.state?.product &&
              canUserEdit(location.state.product, userPermission, currentUser, myEntitlementGroups)
            }
          >
            <CreateProductPage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
